import { FlowStep, Question, SelectInput } from 'app-components'
import { CardNavigation } from '@/components'
import useViewModel, { UtilityPlanOptionProps } from './useViewModel'

const UtilitySignIn = ({ link }: { link: string }) => {
  return (
    <>
      You can sign in to your utility’s website{' '}
      <a href={link} target="_blank" rel="noreferrer">
        here
      </a>
    </>
  )
}

export default function AddUtilityPlanOptionFlowStep(
  props: UtilityPlanOptionProps,
) {
  const {
    utility,
    fileInputRef,
    handleFilesUploaded,
    options,
    handleSelectChange,
  } = useViewModel(props)
  return (
    <FlowStep id="add-utility-plan-flow">
      <FlowStep.Content>
        <CardNavigation id="add-utility-plan-card-navigation" />
        <Question
          title="How would you like to add your utility plan?"
          subtitle={
            utility?.login_url
              ? UtilitySignIn({ link: utility?.login_url })
              : undefined
          }
        >
          <SelectInput
            direction="column"
            options={options}
            onChange={handleSelectChange}
            variant="buttons"
          />
          <input
            onChange={handleFilesUploaded}
            style={{ display: 'none' }}
            multiple
            type="file"
            ref={fileInputRef}
          />
        </Question>
      </FlowStep.Content>
    </FlowStep>
  )
}
